<template>
  <div class="heartbeat">
    {{msg}}
  </div>
</template>

<script>
  import Heartbeat from './Heartbeat.ts';

  export default Heartbeat
  
</script>
